import { render, staticRenderFns } from "./ShouRang.vue?vue&type=template&id=2804d778"
import script from "./ShouRang.vue?vue&type=script&lang=js"
export * from "./ShouRang.vue?vue&type=script&lang=js"
import style0 from "./ShouRang.vue?vue&type=style&index=0&id=2804d778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports